import { Component, EventEmitter, Input, Output } from '@angular/core';
// import { SelectDialogItem } from '@fluxos/ui';
import {SelectDialogItem} from '@fluxos/ui';

@Component({
  selector: 'fl-select-dialog-item',
  templateUrl: './select-dialog-item.component.html',
})
export class SelectDialogItemComponent {
  @Input() item!: SelectDialogItem;
  @Output() selectionChanged = new EventEmitter<boolean>();
}
